module.exports = __webpack_public_path__ + "static/media/insurance-benefits.a1c928a3.aif";